module.exports = __webpack_public_path__ + "static/media/giles.243b3185.jpg";